import API from '../../../../../services/api';

export const RECAMBISTAS_REPORTS_API = {
    new: async (report) => {
        return API.post('/recambistas_report', report).then(res => res.data);
    },
    update: async (report) => {
        return API.put(`/recambistas_report/report.id`, report).then(res => res.data);
    }
}